module.exports = __webpack_public_path__ + "media/images/official/special_migration_14-38b553947a4dbadaa1091367983c838a.jpg";